import React, { useState, useEffect, useContext } from "react";
import { MdEdit, MdAdd } from "react-icons/md";
import { AiOutlineUnorderedList, AiOutlineBars } from "react-icons/ai";
import { BsCardImage } from "react-icons/bs";
import { propertyByUser } from "../actions/propertyByUser";
import { UserContext } from "../context/MainContext";
import { propertyByIds } from "../actions/propertyByIds";
import ModalEditProperty from "./ModalEditProperty";
import { BsFillTrashFill } from "react-icons/bs";
import { propertyDelete } from "../actions/propertyDelete";
import { Link, useNavigate } from "react-router-dom";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import { propertyBulkStatusUpdate } from "../actions/propertyBulkStatusUpdate";
const MyProperties = () => {
  const [properties, setProperties] = useState(null);
  const [property, setProperty] = useState(null);
  const { user, setUser } = useContext(UserContext);
  const [modal, setModal] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [statusUpdateMenu, setStatusUpdateMenu] = useState(false);
  const [showSingleDeleteConfirm, setShowSingleDeleteConfirm] = useState(false);
  const [singleDeleteTarget, setSingleDeleteTarget] = useState(null);
  const [activeSection, setActiveSection] = useState("all"); // "all" | "res-sale" | "res-lease" | "com-sale" | "com-lease" | "sold" | "leased"
  const [statusConfirmModal, setStatusConfirmModal] = useState({
    show: false,
    status: null,
  });
  const [viewMode, setViewMode] = useState("cards");
  const [previewImage, setPreviewImage] = useState(null);
  const nav = useNavigate();
  function currencyFormat(num) {
    if (!num) {
      return "$0?";
    }
    let money = "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return money.substring(0, money.length - 3);
  }
  const handleEdit = (property_id) => {
    propertyByIds({ setProperty }, setModal, property_id);
  };

  const handleDelete = async (property_id) => {
    setSingleDeleteTarget(property_id);
    setShowSingleDeleteConfirm(true);
  };

  const confirmSingleDelete = async () => {
    const property_id = singleDeleteTarget;
    setShowSingleDeleteConfirm(false);
    setSingleDeleteTarget(null);
    if (!property_id) return;
const res = await propertyDelete(property_id, user?.user_id, {
      setProperties,
    });
if (!res || !res.success) {
      alert(`Failed to delete property: ${res?.error || "Unknown error"}`);
      return;
    }

    // Force refresh from server to ensure UI reflects DB
    try {
      await new Promise((resolve) => setTimeout(resolve, 300));
      if (user?.user_id) {
        await propertyByUser({ setProperties }, user.user_id);
      }
    } catch (e) {
}
  };

  const handleSelectProperty = (property_id) => {
    setSelectedProperties((prev) =>
      prev.includes(property_id)
        ? prev.filter((id) => id !== property_id)
        : [...prev, property_id]
    );
  };

  const handleSelectAll = () => {
    if (selectedProperties.length === properties?.length) {
      setSelectedProperties([]);
    } else {
      setSelectedProperties(properties?.map((p) => p.property_id) || []);
    }
  };

  const handleBulkDelete = async () => {
    for (const property_id of selectedProperties) {
      await propertyDelete(property_id, user?.user_id, { setProperties });
    }
    setSelectedProperties([]);
    setShowDeleteConfirm(false);
  };

  const handleBulkStatusUpdate = (newStatus) => {
    setStatusConfirmModal({ show: true, status: newStatus });
    setStatusUpdateMenu(false);
  };

  const confirmStatusUpdate = async () => {
    try {
      const result = await propertyBulkStatusUpdate(
        selectedProperties,
        statusConfirmModal.status,
        user?.user_id,
        { setProperties }
      );

      // Wait a bit for the database to update
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Force refresh the properties
      await propertyByUser({ setProperties }, user?.user_id);

      setSelectedProperties([]);
      setStatusConfirmModal({ show: false, status: null });

      // Show success message
      alert(
        `Successfully updated ${selectedProperties.length} propert${
          selectedProperties.length === 1 ? "y" : "ies"
        } to ${statusConfirmModal.status}`
      );
    } catch (error) {
alert("Failed to update property status. Please try again.");
      setStatusConfirmModal({ show: false, status: null });
    }
  };

  const refreshProperties = () => {
    if (user?.user_id) {
      propertyByUser({ setProperties }, user.user_id);
    }
  };

  useEffect(() => {
    refreshProperties();
  }, [user?.user_id]);

  const filtered = properties?.filter((p) => {
    if (activeSection === "res-sale")
      return (
        p.type === "Residential" &&
        p.for === "Sale" &&
        p.property_status === "Active"
      );
    if (activeSection === "res-lease")
      return (
        p.type === "Residential" &&
        p.for === "Lease" &&
        p.property_status === "Active"
      );
    if (activeSection === "com-sale")
      return (
        p.type === "Commercial" &&
        p.for === "Sale" &&
        p.property_status === "Active"
      );
    if (activeSection === "com-lease")
      return (
        p.type === "Commercial" &&
        p.for === "Lease" &&
        p.property_status === "Active"
      );
    if (activeSection === "sold-res")
      return p.type === "Residential" && p.property_status === "Sold";
    if (activeSection === "sold-com")
      return p.type === "Commercial" && p.property_status === "Sold";
    if (activeSection === "leased-res")
      return p.type === "Residential" && p.property_status === "Leased";
    if (activeSection === "leased-com")
      return p.type === "Commercial" && p.property_status === "Leased";
    return true;
  });

  const getSectionTitle = () => {
    switch (activeSection) {
      case "res-sale":
        return "Active Residential For Sale";
      case "res-lease":
        return "Active Residential For Lease";
      case "com-sale":
        return "Active Commercial For Sale";
      case "com-lease":
        return "Active Commercial For Lease";
      case "sold-res":
        return "Sold Residential";
      case "sold-com":
        return "Sold Commercial";
      case "leased-res":
        return "Leased Residential";
      case "leased-com":
        return "Leased Commercial";
      default:
        return "All My Properties";
    }
  };

  const getStatusBadge = (status, type) => {
    const statusColors = {
      Active: "bg-green-500",
      Sold: "bg-red-500",
      Pending: "bg-yellow-500",
      "Not Active": "bg-gray-500",
      Leased: "bg-red-500",
    };
    const label =
      status === "Leased" && type ? `${type} Leased` : status || "N/A";
    return (
      <span
        className={`${
          statusColors[status] || "bg-gray-400"
        } text-white px-3 py-1 rounded-full text-xs font-semibold`}
      >
        {label}
      </span>
    );
  };

  return (
    <>
      <div className="max-w-[1400px] mx-auto px-4 py-12 mt-8">
        {/* Header Section */}
        <div className="mb-8">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h1 className="text-4xl font-bold text-gray-900 mb-2">
                {getSectionTitle()}
              </h1>
              <p className="text-gray-600 text-lg">
                Manage your listings, track performance, and update property
                details
              </p>
            </div>
            <button
              onClick={() => nav("/residentialAdd")}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all shadow-lg hover:shadow-xl"
            >
              <MdAdd size={24} />
              Add New Property
            </button>
          </div>

          {/* Section Tabs */}
          <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
            <div className="flex flex-wrap gap-2 items-center">
              <button
                onClick={() => setActiveSection("all")}
                className={`px-5 py-2.5 rounded-lg font-semibold transition-all ${
                  activeSection === "all"
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-300 text-gray-700 hover:bg-slate-400"
                }`}
              >
                All
              </button>

              <div className="flex flex-col gap-2 px-4 py-2 bg-white rounded-lg border border-gray-300">
                <h3 className="text-sm font-bold text-gray-700 uppercase">
                  Residential
                </h3>
                <div className="flex gap-2">
                  <button
                    onClick={() => setActiveSection("res-sale")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "res-sale"
                        ? "bg-green-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    For Sale
                  </button>
                  <button
                    onClick={() => setActiveSection("res-lease")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "res-lease"
                        ? "bg-green-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    For Lease
                  </button>
                </div>
              </div>

              <div className="flex flex-col gap-2 px-4 py-2 bg-white rounded-lg border border-gray-300">
                <h3 className="text-sm font-bold text-gray-700 uppercase">
                  Commercial
                </h3>
                <div className="flex gap-2">
                  <button
                    onClick={() => setActiveSection("com-sale")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "com-sale"
                        ? "bg-green-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    For Sale
                  </button>
                  <button
                    onClick={() => setActiveSection("com-lease")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "com-lease"
                        ? "bg-green-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    For Lease
                  </button>
                </div>
              </div>

              <div className="flex flex-col gap-2 px-4 py-2 bg-white rounded-lg border border-gray-300">
                <h3 className="text-sm font-bold text-gray-700 uppercase">
                  Sold
                </h3>
                <div className="flex gap-2">
                  <button
                    onClick={() => setActiveSection("sold-res")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "sold-res"
                        ? "bg-red-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    Residential
                  </button>
                  <button
                    onClick={() => setActiveSection("sold-com")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "sold-com"
                        ? "bg-red-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    Commercial
                  </button>
                </div>
              </div>

              <div className="flex flex-col gap-2 px-4 py-2 bg-white rounded-lg border border-gray-300">
                <h3 className="text-sm font-bold text-gray-700 uppercase">
                  Leased
                </h3>
                <div className="flex gap-2">
                  <button
                    onClick={() => setActiveSection("leased-res")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "leased-res"
                        ? "bg-red-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    Residential
                  </button>
                  <button
                    onClick={() => setActiveSection("leased-com")}
                    className={`px-4 py-1.5 rounded transition-all text-sm ${
                      activeSection === "leased-com"
                        ? "bg-red-600 text-white"
                        : "bg-slate-200 text-gray-700 hover:bg-slate-300"
                    }`}
                  >
                    Commercial
                  </button>
                </div>
              </div>
            </div>

            <div className="flex gap-2 self-start">
              <button
                onClick={() => setViewMode("cards")}
                className={`px-3 py-2 rounded flex items-center gap-2 transition-all ${
                  viewMode === "cards"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-300 text-gray-700"
                }`}
                title="Card View"
              >
                <AiOutlineUnorderedList size={20} />
                <span className="text-sm font-medium">Card View</span>
              </button>
              <button
                onClick={() => setViewMode("table")}
                className={`px-3 py-2 rounded flex items-center gap-2 transition-all ${
                  viewMode === "table"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-300 text-gray-700"
                }`}
                title="Detailed View"
              >
                <AiOutlineBars size={20} />
                <span className="text-sm font-medium">Detailed View</span>
              </button>
            </div>
          </div>

          {/* Stats Summary */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4 mb-6">
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
              <p className="text-gray-600 text-sm font-medium">
                Total Properties Listed
              </p>
              <p className="text-3xl font-bold text-gray-900">
                {properties?.length || 0}
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
              <p className="text-gray-600 text-sm font-medium">
                Total Active Listings
              </p>
              <p className="text-3xl font-bold text-green-600">
                {properties?.filter((p) => p.property_status === "Active")
                  .length || 0}
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
              <p className="text-gray-600 text-sm font-medium">
                Total Leased Listings
              </p>
              <p className="text-3xl font-bold text-blue-600">
                {properties?.filter((p) => p.property_status === "Leased")
                  .length || 0}
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
              <p className="text-gray-600 text-sm font-medium">
                Total Sold Listings
              </p>
              <p className="text-3xl font-bold text-red-600">
                {properties?.filter((p) => p.property_status === "Sold")
                  .length || 0}
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
              <p className="text-gray-600 text-sm font-medium">
                Total Withdrawn / Expired Listings
              </p>
              <p className="text-3xl font-bold text-orange-600">
                {properties?.filter((p) =>
                  ["Withdrawn", "Expired"].includes(p.property_status)
                ).length || 0}
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
              <p className="text-gray-600 text-sm font-medium">Total Views</p>
              <p className="text-3xl font-bold text-indigo-600">
                {properties?.reduce(
                  (sum, p) => sum + (p.impressions || 0),
                  0
                ) || 0}
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
              <p className="text-gray-600 text-sm font-medium">
                Total Keys Earned
              </p>
              <p className="text-3xl font-bold text-purple-600">
                {properties?.reduce((sum, p) => sum + (p.keys || 0), 0) || 0}
              </p>
            </div>
          </div>

          {/* Bulk Actions */}
          {selectedProperties.length > 0 && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <div className="flex justify-between items-center flex-wrap gap-4">
                <span className="text-blue-900 font-medium">
                  {selectedProperties.length} propert
                  {selectedProperties.length === 1 ? "y" : "ies"} selected
                </span>
                <div className="flex gap-2 flex-wrap">
                  <div className="relative">
                    <button
                      onClick={() => setStatusUpdateMenu(!statusUpdateMenu)}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-all"
                    >
                      Update Status ▼
                    </button>
                    {statusUpdateMenu && (
                      <div className="absolute top-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10 min-w-[200px]">
                        <button
                          onClick={() => handleBulkStatusUpdate("Active")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Active
                        </button>
                        <button
                          onClick={() => handleBulkStatusUpdate("Leased")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Leased
                        </button>
                        <button
                          onClick={() => handleBulkStatusUpdate("Sold")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Sold
                        </button>
                        <button
                          onClick={() => handleBulkStatusUpdate("Pending")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Pending
                        </button>
                        <button
                          onClick={() => handleBulkStatusUpdate("Not Active")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Temporarily Off Market
                        </button>
                        <button
                          onClick={() => handleBulkStatusUpdate("Withdrawn")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Withdrawn
                        </button>
                        <button
                          onClick={() => handleBulkStatusUpdate("Expired")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Expired
                        </button>
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => setShowDeleteConfirm(true)}
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-all"
                  >
                    Delete Selected
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Properties Grid */}
        <div className="space-y-4">
          {/* Select All */}
          {properties && properties.length > 0 && (
            <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200 flex items-center gap-3">
              <input
                type="checkbox"
                checked={selectedProperties.length === properties.length}
                onChange={handleSelectAll}
                className="w-5 h-5 cursor-pointer"
              />
              <span className="font-medium text-gray-700">Select All</span>
            </div>
          )}

          {viewMode === "cards" ? (
            filtered?.map((property, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden hover:shadow-lg transition-all"
              >
                <div className="flex flex-col md:flex-row">
                  {/* Checkbox */}
                  <div className="flex items-center justify-center p-4 bg-gray-50">
                    <input
                      type="checkbox"
                      checked={selectedProperties.includes(
                        property.property_id
                      )}
                      onChange={() =>
                        handleSelectProperty(property.property_id)
                      }
                      className="w-5 h-5 cursor-pointer"
                    />
                  </div>

                  {/* Property Image */}
                  <div className="w-full md:w-48 h-32 flex-shrink-0">
                    <img
                      src={cloudinaryUrl(property.media_url?.split(",")[0])}
                      alt="Property"
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Property Details */}
                  <div className="flex-1 p-4">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <Link
                          to={`/property/${property.property_id}`}
                          className="text-xl font-bold text-gray-900 hover:text-blue-600 transition-colors"
                        >
                          {property.street_number} {property.street_name}
                        </Link>
                        <p className="text-gray-600">
                          {property.city}, TX {property.zip}
                        </p>
                      </div>
                      <div className="flex gap-2 items-center">
                        <span
                          className={`${
                            property.type === "Residential"
                              ? "bg-blue-500"
                              : "bg-purple-500"
                          } text-white px-3 py-1 rounded-full text-xs font-semibold`}
                        >
                          {property.type || "N/A"}
                        </span>
                        {!["Sold", "Leased"].includes(
                          property.property_status
                        ) && (
                          <span
                            className={`${
                              property.for === "Sale"
                                ? "bg-green-500"
                                : "bg-green-500"
                            } text-white px-3 py-1 rounded-full text-xs font-semibold`}
                          >
                            {property.for === "Sale" ? "For Sale" : "For Lease"}
                          </span>
                        )}
                        {getStatusBadge(
                          property.property_status,
                          property.type
                        )}
                      </div>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-3">
                      <div>
                        <p className="text-gray-500 text-xs">Price</p>
                        {property.property_status === "Leased" ? (
                          <div className="space-y-1">
                            <p className="font-bold text-gray-900">
                              Listed Lease Price:{" "}
                              {currencyFormat(property.price)}
                              {property.for === "Lease" ? "/mo" : ""}
                            </p>
                            <p className="font-semibold text-blue-700">
                              Leased Price:{" "}
                              {property.sold_for
                                ? currencyFormat(property.sold_for)
                                : "N/A"}
                              {property.for === "Lease" ? "/mo" : ""}
                            </p>
                          </div>
                        ) : (
                          <p className="font-bold text-gray-900">
                            {currencyFormat(property.price)}
                            {property.for === "Lease" ? "/mo" : ""}
                          </p>
                        )}
                      </div>
                      <div>
                        <p className="text-gray-500 text-xs">Beds / Baths</p>
                        <p className="font-bold text-gray-900">
                          {property.beds_total || 0} /{" "}
                          {property.baths_full || 0}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-xs">Views</p>
                        <p className="font-bold text-blue-600">
                          {property.impressions || 0}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-xs">Keys Generated</p>
                        <p className="font-bold text-gray-900">
                          {property.keys_earned || 0}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="flex md:flex-col gap-2 p-4 bg-gray-50 justify-center">
                    {property.property_status !== "Sold" && (
                      <button
                        onClick={() => handleEdit(property.property_id)}
                        className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-all"
                      >
                        <MdEdit size={20} />
                        Edit
                      </button>
                    )}
                    <button
                      onClick={() => handleDelete(property.property_id)}
                      className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-all"
                    >
                      <BsFillTrashFill size={18} />
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="overflow-x-auto bg-white rounded-lg shadow-md border border-gray-200">
              <table className="w-full border-collapse text-sm">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border px-3 py-2 text-center w-12">
                      Select
                    </th>
                    <th className="border px-4 py-2 text-center">Key#</th>
                    <th className="border px-4 py-2 text-center">Preview</th>
                    <th className="border px-4 py-2 text-left">Address</th>
                    <th className="border px-4 py-2 text-left">City</th>
                    <th className="border px-4 py-2 text-center">Type</th>
                    <th className="border px-4 py-2 text-center">For</th>
                    <th className="border px-4 py-2 text-center">Status</th>
                    <th className="border px-4 py-2 text-center">Beds</th>
                    <th className="border px-4 py-2 text-center">Baths</th>
                    <th className="border px-4 py-2 text-center">
                      Living Sqft
                    </th>
                    <th className="border px-4 py-2 text-right">Price</th>
                    <th className="border px-4 py-2 text-center">Views</th>
                    <th className="border px-4 py-2 text-center">Keys</th>
                    <th className="border px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered?.map((property, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="border px-3 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={selectedProperties.includes(
                            property.property_id
                          )}
                          onChange={() =>
                            handleSelectProperty(property.property_id)
                          }
                          className="w-5 h-5 cursor-pointer"
                        />
                      </td>
                      <td className="border px-4 py-2 text-center font-mono">
                        <Link
                          to={`/property/${property.property_id}`}
                          className="text-blue-600 hover:underline"
                        >
                          {property.property_id || "N/A"}
                        </Link>
                      </td>
                      <td className="border px-4 py-2 text-center">
                        <button
                          type="button"
                          className="inline-flex items-center justify-center text-gray-600 hover:text-blue-600"
                          onClick={() => {
                            const url = property?.media_url?.split(",")[0];
                            if (url) setPreviewImage(cloudinaryUrl(url));
                          }}
                        >
                          <BsCardImage size={18} />
                        </button>
                      </td>
                      <td className="border px-4 py-2">
                        {property.street_number} {property.street_name}
                      </td>
                      <td className="border px-4 py-2">{property.city}</td>
                      <td className="border px-4 py-2 text-center">
                        {property.type || "N/A"}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {property.for || "N/A"}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {property.property_status || "N/A"}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {property.beds_total || "N/A"}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {property.baths_full || "N/A"}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {property.living_sqft
                          ? property.living_sqft.toLocaleString()
                          : "N/A"}
                      </td>
                      <td className="border px-4 py-2 text-right font-semibold">
                        {currencyFormat(property.price)}
                        {property.for === "Lease" ? "/mo" : ""}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {property.impressions || 0}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {property.keys_earned || 0}
                      </td>
                      <td className="border px-4 py-2">
                        <div className="flex flex-wrap gap-2 justify-center">
                          <button
                            type="button"
                            onClick={() => {
                              const pid = property?.property_id;
                              if (!pid || !/^\d+$/.test(String(pid))) {
                                if (process.env.NODE_ENV !== "production") {
}
                                return;
                              }
                              nav(`/property/${pid}`);
                            }}
                            className="px-3 py-1 bg-slate-800 text-white rounded text-xs hover:bg-slate-900 transition-colors"
                          >
                            View
                          </button>
                          {property.property_status !== "Sold" && (
                            <button
                              type="button"
                              onClick={() => handleEdit(property.property_id)}
                              className="px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 transition-colors"
                            >
                              Edit
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => handleDelete(property.property_id)}
                            className="px-3 py-1 bg-red-600 text-white rounded text-xs hover:bg-red-700 transition-colors"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {previewImage && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-2xl max-w-3xl w-full mx-4 overflow-hidden">
                <div className="flex justify-between items-center px-4 py-3 border-b">
                  <h3 className="text-lg font-semibold">Image Preview</h3>
                  <button
                    className="text-gray-600 hover:text-black"
                    onClick={() => setPreviewImage(null)}
                  >
                    Close
                  </button>
                </div>
                <div className="bg-black">
                  <img
                    src={previewImage}
                    alt="Property"
                    className="w-full max-h-[70vh] object-contain"
                  />
                </div>
              </div>
            </div>
          )}

          {(!properties || properties.length === 0) && (
            <div className="bg-white rounded-lg shadow-md border border-gray-200 p-12 text-center">
              <p className="text-gray-500 text-lg mb-4">
                You haven't listed any properties yet
              </p>
              <button
                onClick={() => nav("/residentialAdd")}
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all"
              >
                <MdAdd size={24} />
                Add Your First Property
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Confirm Deletion
            </h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete {selectedProperties.length}{" "}
              propert{selectedProperties.length === 1 ? "y" : "ies"}? This
              action cannot be undone.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg font-medium transition-all"
              >
                Cancel
              </button>
              <button
                onClick={handleBulkDelete}
                className="flex-1 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-all"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Single-item Delete Confirmation Modal */}
      {showSingleDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Confirm Deletion
            </h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete property #{singleDeleteTarget}?
              This action cannot be undone.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => {
                  setShowSingleDeleteConfirm(false);
                  setSingleDeleteTarget(null);
                }}
                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg font-medium transition-all"
              >
                Cancel
              </button>
              <button
                onClick={confirmSingleDelete}
                className="flex-1 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-all"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Status Update Confirmation Modal */}
      {statusConfirmModal.show && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Confirm Status Update
            </h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to update the status of{" "}
              {selectedProperties.length} propert
              {selectedProperties.length === 1 ? "y" : "ies"} to{" "}
              <span className="font-semibold">{statusConfirmModal.status}</span>
              ?
            </p>
            <div className="flex gap-4">
              <button
                onClick={() =>
                  setStatusConfirmModal({ show: false, status: null })
                }
                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg font-medium transition-all"
              >
                Cancel
              </button>
              <button
                onClick={confirmStatusUpdate}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-all"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {modal && (
        <ModalEditProperty
          modal={modal}
          setModal={setModal}
          property={property}
          setProperty={setProperty}
          onPropertyUpdated={refreshProperties}
        />
      )}
    </>
  );
};

export default MyProperties;
